export default __webpack_public_path__ + "static/media/extension-04.82d30179.png";